import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-responses-weight-criteria',
  templateUrl: './responses-weight-criteria.component.html',
  styleUrls: ['./responses-weight-criteria.component.scss']
})
export class ResponsesWeightCriteriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
